import { Component, Output, Input , EventEmitter, Injectable} from '@angular/core';

/**
 * Generated class for the UpsellProductBoxComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Injectable({ providedIn: 'root' })
@Component({
  selector: 'upsell-product-box',
  templateUrl: 'upsell-product-box.html',
  styleUrls: ['upsell-product-box.scss'],
})
export class UpsellProductBoxComponent {
  @Input() title: string = '';
  @Input() image: string = 'assets/img/No-Image-Available.jpg';
  @Input() imageAlt: string = '';
  @Input() auxImg: any = null;
  @Input() auxImgAlt: string = '';
  @Input() subTitle: string = '';
  @Input() regularPrice: number = 0;
  @Input() instantSavings: number = 0;
  @Input() yourPrice: number = 0;
  @Input() currency: string = 'USD';  // TOUC-14710
  @Input() currencySymbol: string = '$';
  @Input() officialCurrency: string = 'USD';
  @Input() braintreeCurrencyConversion: number = 1;

  @Input() isAmazon: boolean = false;
  @Input() isPlaceOrder: boolean = true;
  @Input() showImage: boolean = true;
  @Input() productBoxCTA: boolean = false;
  
  @Input() subtitle: string = "Subtitle";
  @Input() buttonId: string = ''; //What does this do? Can I remove?
  @Input() walletId: string = ''; //What does this do? Can I remove?
  @Input() regularText: string = 'Regular Price';
  @Input() instantSavingsText: string = 'Instant Savings';
  @Input() yourPriceText: string = 'Your Price';
  // Legacy event emitter - keeping for backward compatibility but deprecated
  @Output() button_emitter: EventEmitter<boolean> = new EventEmitter();
  @Output() amazonPaymentEmitter: EventEmitter<void> = new EventEmitter();
  //Provide external method to navigate to next page over funnel
  @Output() eventEmitter: EventEmitter<boolean> = new EventEmitter();
  
  // Legacy property - keeping for backward compatibility but deprecated
  button_value: boolean;

  @Input() buttonYesText: string = '';
  @Input() buttonNoText: string = '';
  
  buttonValue: boolean = false;

  constructor() {}

  payWithAmazon() {
    this.amazonPaymentEmitter.emit();
  }

  nextPage(buttonValue: boolean) {
    this.buttonValue = buttonValue ? true : false;
    this.eventEmitter.emit(this.buttonValue);
  }
}
 